import actions from './actions';

const { setUnreadNotifications } = actions;

export const populateUnreadNotifications = notifications => {
  return dispatch => {
    dispatch(setUnreadNotifications(notifications));
  };
};
